import { useDispatchBaseEvent, useSubscribeToBaseEvent } from "../useDispatchBaseEvent";

export const DELETE_ACTIVE_OBJECT_EVENT_NAME = "useDeleteActiveObjectEvent";

type DeleteActiveObjectEvent = {
  type: typeof DELETE_ACTIVE_OBJECT_EVENT_NAME;
  payload: void;
};

export function useDispatchDeleteActiveObjectEvent() {
  return useDispatchBaseEvent<DeleteActiveObjectEvent>(DELETE_ACTIVE_OBJECT_EVENT_NAME);
}

export function useSubscribeToDeleteActiveObjectEvent(handler: (payload: DeleteActiveObjectEvent["payload"]) => void) {
  useSubscribeToBaseEvent<DeleteActiveObjectEvent>(DELETE_ACTIVE_OBJECT_EVENT_NAME, handler);
}
